import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, PaginatedPackageAutocompleteForExpectationList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

const PACKAGE_UTILIZATION_EXPECTATIONS_AUTO_COMPLETE_QUERY_KEY =
  'package-utilization-expectations-auto-complete';

interface UseAutoCompletePackageForExpectationsProps {
  search?: string;
  hasExpectation?: boolean;
  limit: number;
  offset: number;
}

function useAutoCompletePackageForExpectations({
  search,
  hasExpectation,
  limit = 100,
  offset = 0,
}: UseAutoCompletePackageForExpectationsProps): UseQueryResult<
  AxiosResponse<PaginatedPackageAutocompleteForExpectationList>
> {
  const fetchAutoCompletePackageForExpectations = (): Promise<
    AxiosResponse<PaginatedPackageAutocompleteForExpectationList>
  > => {
    const params: UrlParams = {
      limit: limit.toString(),
      offset: offset.toString(),
    };

    if (search) {
      params.search = search;
    }

    if (hasExpectation !== undefined) {
      params.has_expectation = hasExpectation ? 'true' : 'false';
    }

    return client.get(`package-utilization-expectations/package-auto-complete/?${encodeUrlParams(params)}`);
  };

  return useQuery({
    queryKey: [
      PACKAGE_UTILIZATION_EXPECTATIONS_AUTO_COMPLETE_QUERY_KEY,
      search,
      hasExpectation,
      limit,
      offset,
    ],
    queryFn: fetchAutoCompletePackageForExpectations,
  });
}

export default useAutoCompletePackageForExpectations;
export { PACKAGE_UTILIZATION_EXPECTATIONS_AUTO_COMPLETE_QUERY_KEY };
